import React, { useContext, useEffect, useState } from 'react';
import { Card, Grid, Typography, useMediaQuery, Box, Tabs, Tab, Modal, TextField, Chip, InputAdornment, FormControl, InputLabel, MenuItem, Button } from '@mui/material';
import { useStyles } from './style';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { useNavigate } from 'react-router-dom';
import { AuthUser } from '../../interfaces/Contexts';
import CustomTabPanel from '../../Components/TabsComponent';
import AppliedJobCards from '../../Components/JobCards';
import { AppButton } from '../../Components/AppButton';
import RegisteredEvent from './events';
import IdCard from './components/IdCardModel';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import KeyboardBackspaceSharpIcon from '@mui/icons-material/KeyboardBackspaceSharp';
import CommunityCard from './components/CommunityCard';
import CampaingsCard from './components/CampaingsCard';
import EventsCard from './components/EventCard';
import routes from '../../Utils/routes';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TableContainer from './components/Table';
import AddAcademicRecord from './components/AddAcademicRecord';
import AddEmployeeDetails from './components/AddEmployeeDetail';
import AddCertificateData from './components/AddCertificateData';
import AddSkill from './components/AddSkill';
import { useTheme } from '@mui/material/styles';
import { deleteAcademicRecord, deleteCertificate, deleteEmployment, getEventsData, postBasicProfileSetting } from '../../Utils/apiService';
import { IEventCards } from '../../interfaces/Profile';
import KenLoader from '../../GlobalComponents/KenLoader';
import KenColors from '../../Helpers/Themes/kenColors';
import PdfImg from '../../Assets/pdfimg.png';
import resumeNoDataImg from '../../Assets/resumeNoData.png';
import googleImg from '../../Assets/googleImg.png';
import AcademicRecordImg from '../../Assets/AcedemicRecord.png';
import moment from 'moment';
import {
  getAcademicRecords,
  getBasicProfileSetting,
  getEmployeementDetails,
  getJobPreferenceSetting,
  getJobs,
  getJobsApply,
  getJobsBookmark,
  getJobsResume,
  getProfileCertificateDetails,
  getMentorshipDetails
} from '../../Utils/apiService';
import MentorshipContainer from '../Mentorship/Mentorship';
import GroupsContent from './components/GroupsContent';
import BusinessesContent from './components/BusinessesContent';
import FundraiseContent from './components/FundraiseContent';
import CareerDetailsContent from './components/CareerDetailsContent';
import MentorshipContent from './components/MentorshipContent';
import EventsContent from './components/EventsContent';
import CampaignDialog from '../Fundraise/campaignupload';

import PersonalInformation from '../Settings/components/PersonalInformation';

interface JobTitle {
  title: string;
}
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
export default function MyProfile() {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const theme = useTheme();
  const navigate = useNavigate();
  // const isMobile = useMediaQuery('(max-width:1025px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const [openPrefer, setOpenPrefer] = useState(false);
  const [openLinkedIn, setOpenLinkedIn] = useState(false);
  const [openAcademicRecord, setOpenAcademicRecord] = useState(false);
  const [openEmployeeAdd, setOpenEmployeeAdd] = useState(false);
  const [openEmployeeEdit, setOpenEmployeeEdit] = useState(false);
  const [openCertificateAdd, setOpenCertificateAdd] = useState(false);
  const [openCertificateEdit, setOpenCertificateEdit] = useState(false);
  const [openSkillsAdd, setOpenSkillsAdd] = useState(false);
  const [openSkillsEdit, setOpenSkillsEdit] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [eventsData, setEventsData] = useState<any>({
    upcoming: [],
    cancelled: [],
    completed: [],
    filteredUpcoming: [],
    filteredCancelled: [],
    filteredCompleted: [],
  });

  const [value, setValue] = useState(() => {
    // Try to get saved tab index from localStorage
    const savedTab = localStorage.getItem('myProfileActiveTab');
    return savedTab ? parseInt(savedTab, 10) : 0;
  });
  const [searchValue, setSearchValue] = useState('');

  // Tab configuration for vertical tabs
  const tabConfig = [
    { label: 'Personal Details', index: 0 },
    { label: 'Career', index: 1 },
    { label: 'Academic Records', index: 2 },
    { label: 'Events', index: 3 },
    { label: 'Groups', index: 4 },
    { label: 'Mentorship', index: 5 },
    { label: 'Fundraise', index: 6 },
    { label: 'Businesses', index: 7 },

  ];

  // Filter tabs based on search value
  const filteredTabs = React.useMemo(() => {
    if (!searchValue.trim()) {
      return tabConfig;
    }
    return tabConfig.filter((tab: any) =>
      tab.label.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [searchValue]);
  const [eventStatus, setEventStatus] = useState<boolean>(true);
  const [carrierJobs, setCarrierJobs] = useState('AppliedJobs');
  const [academicRecords, setAcademicRecords] = useState('RequestCertificate');
  const [acedmicStatus, setAcademicStatus] = useState(false);
  const [showCareerDetails, setShowCareerDetails] = useState(false);
  const [careerDetailsTab, setCareerDetailsTab] = useState('Applied');
  const [campaignsStatus, setCampaignsStatus] = useState(false);
  const [semester, setSemester] = React.useState('');
  const [eventData, setEventData] = useState('upcoming');
  const [appliedData, setAppliedData] = useState([]);
  const [savedJobsData, setSavedJobsData] = useState([]);
  const [resumeDataDetails, setResumeDataDetails] = useState([]);
  const [selectedSkillSet, setSelectedSkillSet] = useState<JobTitle[]>([]);
  const [employeeDetails, setEmployeeDetails] = useState<any[]>([]);
  const [employeeDetailVal, setEmployeeDetailVal] = useState([]);
  const [jobsData, setJobsData] = useState([]);
  const [certificateDetails, setCertificateDetails] = useState<any[]>([]);
  const [certificateDetailVal, setCertificateDetailVal] = useState([]);
  const [certificateId, setCertificateId] = useState('');
  const [employmentId, setEmploymentId] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [academicRecordData, setAcademicRecordData] = useState<any[]>([]);
  const [academicRecordVal, setAcademicRecordDataVal] = useState(null);
  const [preference, setPreference] = useState([]);
  const [preferenceImg, setPreferenceImg] = useState([]);
  const [preferenceData, setPreferenceData] = useState([]);
  const [profileData, setProfileData] = useState<any>(null);
  const [preferStatus, setPreferStatus] = useState(false);
  const [academicRecordStatus, setAcademicRecordStatus] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [openDeleteConfirmEmploy, setOpenDeleteConfirmEmploy] = useState(false);
  const [editSkills, setEditSkills] = useState(false);
  const [skill, setSkill] = useState<any>([]);
  const [AllYourMentees, setAllYourMentees] = useState<any[]>([]);
  const [featuredCardData, setFeaturedCardData] = useState<any[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);



  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenPrefer = () => setOpenPrefer(true);
  const handleClosePrefer = () => { getProfileSetting(); setOpenPrefer(false); }
  const handleOpenLinkedIn = () => setOpenLinkedIn(true);
  const handleCloseLinkedIn = () => {
    setOpenLinkedIn(false);
  }
  const handleOpenAcademicRecord = () => setOpenAcademicRecord(true);
  const handleCloseAcademicRecord = () => {
    setOpenAcademicRecord(false);
  }
  const handleOpenEmployeeAdd = () => setOpenEmployeeAdd(true);
  const handleCloseEmployeeAdd = () => setOpenEmployeeAdd(false);
  const handleOpenEmployeeEdit = () => setOpenEmployeeEdit(true);
  const handleCloseEmployeeEdit = () => setOpenEmployeeEdit(false);
  const handleOpenCertificateAdd = () => setOpenCertificateAdd(true);
  const handleCloseCertificateAdd = () => { getCertificateDetails(); setOpenCertificateAdd(false); }
  const handleOpenCertificateEdit = () => setOpenCertificateEdit(true);
  const handleCloseCertificateEdit = () => { getCertificateDetails(); setOpenCertificateEdit(false); }
  const handleOpenSkillsAdd = () => setOpenSkillsAdd(true);
  const handleCloseSkillsAdd = () => {
    getProfileSetting();
    setOpenSkillsAdd(false);
  }
  const handleOpenSkillsEdit = () => setOpenSkillsEdit(true);
  const handleCloseSkillsEdit = () => setOpenSkillsEdit(false);
  const handleChangeSemester = (event: SelectChangeEvent) => {
    setSemester(event.target.value as string);
  };

  const handleSave = async () => {
    try {
      const payload = {
        accountId: userData.applicantId,
        isProfilePicture: false,
        isBasicDetails: true,
        hidePhone: false,
        hideEmail: false,
        skills: skill.join(','),
      };
      await postBasicProfileSetting(payload);
      setEditSkills(false);
      console.log('Skills updated successfully');
    } catch (error) {
      console.error('Error saving skills:', error);
    }
  };

  const handleSearchChange = (value: any) => {
    if (value === '' || !value) {
      setEventsData({ ...eventsData, filteredUpcoming: eventsData.upcoming || [], filteredCancelled: eventsData.cancelled || [], filteredCompleted: eventsData.completed || [] });
    } else {
      const filteredData = [...eventsData.filteredUpcoming, ...eventsData.filteredCancelled, ...eventsData.filteredCompleted].filter((items: any) => {
        return items.eventTitle.toLowerCase().includes(value.toLowerCase());
      });

      const upcomingEvents = filteredData
        ?.filter((items: any) => {
          return items?.isUpcoming === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      const cancelledEvents = filteredData
        ?.filter((items: any) => {
          return items?.isCancel === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      const pastEvents = filteredData
        ?.filter((items: any) => {
          return items?.ispast === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      setEventsData({
        ...eventsData,
        filteredUpcoming: upcomingEvents || [],
        filteredCancelled: cancelledEvents || [],
        filteredCompleted: pastEvents || [],
      });
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // Save to localStorage
    localStorage.setItem('myProfileActiveTab', newValue.toString());

    // Mobile scroll behavior - scroll to content area when tab is clicked
    if (isMobile) {
      // Small delay to ensure state is updated
      setTimeout(() => {
        const contentElement = document.getElementById('profile-content-area');
        if (contentElement) {
          contentElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }, 100);
    }
  };
  const [opens, setOpens] = React.useState(false);
  const handleClick = () => setOpens(true);
  const handleCloses = () => {
    setOpens(false);
  };
  // const handleClick = () => {
  //   // navigate(routes.resumeBuilder);
  //   // navigate(`${routes.resumeLibrary}?open=true`);
  // };

  const getJobAppliedDetails = () => {
    getJobsApply(userData.applicantId)
      .then((res) => {
        const appliedJobs = res.data.appliedJobs || [];
        setAppliedData(appliedJobs);
      })
      .catch((err) => {
        console.error(err);
        setAppliedData([]);
      });
  };

  const getJobDetails = () => {
    getJobs(userData.applicantId)
      .then((res) => {
        const myJobs = res.data.myJobs || [];
        setJobsData(myJobs);
      })
      .catch((err) => {
        console.error(err);
        setJobsData([]);
      });
  };

  const getSavedJobsDetails = () => {
    getJobsBookmark(userData.applicantId)
      .then((res) => {
        const savedJobs = res.data.savedJobs || [];
        setSavedJobsData(savedJobs);
      })
      .catch((err) => {
        console.error(err);
        setSavedJobsData([]);
      });
  };

  const getResumeData = () => {
    getJobsResume(userData.applicantId)
      .then((res) => {
        console.log('res68764', res);
        setResumeDataDetails(res.data.contactsWithFiles?.[0]?.files);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getEmployeeDetails = () => {
    getEmployeementDetails(userData.applicantId)
      .then((res) => {
        console.log('res68764234', res);
        setEmployeeDetails(res?.employmentDetails);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getCertificateDetails = () => {
    getProfileCertificateDetails(userData.applicantId)
      .then((res) => {
        console.log('res68764234', res);
        setCertificateDetails(res?.certificateDetails);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getJobPreference = () => {
    getJobPreferenceSetting(userData.applicantId)
      .then((res) => {
        console.log('34654654', res);
        const parseJobTitles = (titlesString: string): JobTitle[] => {
          return titlesString?.split(';').map((title) => ({
            title: title.trim(),
          }));
        };
        const skillset = parseJobTitles(res.jobPreferences.Skill_set__c);
        setSelectedSkillSet(skillset);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getProfileSetting = () => {
    getBasicProfileSetting(userData.applicantId)
      .then((res) => {
        console.log('res6876423432423', res);
        setProfileData(res.alumniDetails);
        setSkill(res.accountDetails.Skills__c?.split(',') || []);
        setLinkedIn(res.accountDetails.LinkedIn_URL__c);
        const data = res.alumniDetails.Preferences__c?.split(';') ? res.alumniDetails.Preferences__c?.split(';') : ["I would like to be a mentors"];
        let preferenceData = res.staticFiles;
        const parsedObject = JSON.parse(preferenceData);
        const preferData = res?.staticFiles;
        const input = JSON.parse(preferData);
        const values = data.map((key: any) => {
          const value = input[key];
          return `data:image/png;base64,${value}`;
        });
        setPreference(data);
        setPreferenceImg(values);
        setPreferenceData(parsedObject);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getMenteeDetails = () => {
    getMentorshipDetails(userData?.applicantId).then((res) => {
      const mentees = res?.data?.data?.MenteeDetails || [];
      setAllYourMentees(mentees);
      setFeaturedCardData(mentees);
    }).catch((err) => {
      console.error(err);
    });
  };
  const getAcademicsRecords = () => {
    getAcademicRecords(userData.applicantId)
      .then((res) => {
        console.log('reshghg3534', res);

        setAcademicRecordData(res?.academicRecords);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getJobAppliedDetails();
    getResumeData();
    getJobPreference();
    getEmployeeDetails();
    getJobDetails();
    getSavedJobsDetails();
    getCertificateDetails();
    getProfileSetting();
    getMenteeDetails();
    getAcademicsRecords();
  }, [preferStatus, academicRecordStatus, openLinkedIn]);
  useEffect(() => {
    getAcademicsRecords();
  }, [openAcademicRecord])

  useEffect(() => {
    getProfileSetting();
  }, [editSkills])
  const createRecord = (items: any) => {
    let data: IEventCards = {
      endTime: items?.endTime,
      Id: items?.Id,
      startDate: items?.startDate,
      startTime: items?.startTime,
      eventTitle: items?.eventTitle,
      endDate: items?.endDate,
      isCancel: items?.isCancel,
      ispast: items?.ispast,
      isUpcoming: items?.isUpcoming,
      sessionLocationType: '',
      category: ''
    };

    return data;
  };

  useEffect(() => {
    setLoading(true);

    getEventsData()
      .then((res) => {
        const data = JSON.parse(res?.data);

        const upcomingEvents = data
          ?.filter((items: any) => {
            return items?.isUpcoming === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        const cancelledEvents = data
          ?.filter((items: any) => {
            return items?.isCancel === true;
          })

          .map((items: any) => {
            return createRecord(items);
          });

        const pastEvents = data
          ?.filter((items: any) => {
            return items?.ispast === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        setEventsData({
          upcoming: upcomingEvents || [],
          cancelled: cancelledEvents || [],
          completed: pastEvents || [],
          filteredUpcoming: upcomingEvents || [],
          filteredCancelled: cancelledEvents || [],
          filteredCompleted: pastEvents || [],
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  const renderEvents = (status: 'upcoming' | 'completed' | 'cancelled') => {
    switch (status) {
      case 'upcoming':
        return eventsData.filteredUpcoming.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      case 'cancelled':
        return eventsData.filteredCancelled.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      case 'completed':
        return eventsData.filteredCompleted.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      default:
        return null;
    }
  };
  console.log('windows12', window.innerWidth);
  const handleDownload = (title: any, pdf: any) => {
    // Replace with your Base64 encoded PDF string
    const base64Data = pdf;
    const fileName = title;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  };
  function handleCloseDeleteConfirm(): void {

    setOpenDeleteConfirm(false);
    setOpenDeleteConfirmEmploy(false);
  }

  function handleDeleteCertificate(): void {
    if (certificateId) {
      // Call the API to delete the certificate
      // Assuming deleteCertificate is a function that takes an ID and deletes the certificate
      deleteCertificate(certificateId)
        .then(() => {
          // Update the state to reflect the deletion
          setCertificateDetails((prevDetails) => prevDetails.filter((cert) => cert.Id !== certificateId));
          setOpenDeleteConfirm(false);
        })
        .catch((err) => {
          console.error('Error deleting certificate:', err);
        });
    }
  }

  function handleDeleteAcadamics(): void {
    if (certificateId) {
      // Call the API to delete the certificate
      // Assuming deleteCertificate is a function that takes an ID and deletes the certificate
      deleteAcademicRecord(certificateId)
        .then(() => {
          // Update the state to reflect the deletion
          setAcademicRecordData((prevDetails) => prevDetails.filter((cert) => cert.Id !== certificateId));
          setOpenDeleteConfirm(false);
        })
        .catch((err) => {
          console.error('Error deleting certificate:', err);
        });
    }
  }

  function handleDeleteEmployment(): void {

    if (employmentId) {
      // Call the API to delete the certificate
      // Assuming deleteCertificate is a function that takes an ID and deletes the certificate
      deleteEmployment(employmentId)
        .then(() => {
          // Update the state to reflect the deletion
          setEmployeeDetails((prevDetails: any[]) => prevDetails.filter((cert) => cert.Id !== employmentId));
          setOpenDeleteConfirmEmploy(false);
        })
        .catch((err) => {
          console.error('Error deleting certificate:', err);
        });
    }
  }

  return (
    <div>
      {loading && <KenLoader />}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} lg={3} xl={3} md={12}>
          <Card
            id="profile-tabs-area"
            className={classes.profileCard}
            sx={{
              height: { xs: 'auto', sm: '82.5vh' },
              display: 'flex',
              flexDirection: 'column',
              p: { xs: 1, sm: 2 }
            }}
          >
            {/* Search Field */}
            <Box sx={{ mb: 2 }}>
              <TextField
                placeholder="Search"
                variant="outlined"
                size="small"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ fontSize: '18px' }} />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '14px',
                    borderRadius: '8px',
                  }
                }}
              />
            </Box>

            {/* Vertical Tabs */}
            <Box sx={{ flex: 1, overflow: 'auto', mb: 2 }}>
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                sx={{
                  width: '100%',
                  '& .MuiTabs-indicator': {
                    display: 'none',
                  },
                  '& .MuiTab-root': {
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    alignItems: 'flex-start',
                    minHeight: '48px',
                    padding: '12px 16px',
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#666',
                    textTransform: 'none',
                    '&.Mui-selected': {
                      backgroundColor: '#FFF4E6',
                      color: '#000',
                      fontWeight: 500,
                      borderRight: '3px solid #FF9500',
                    },
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                    }
                  }
                }}
              >
                {filteredTabs.map((tab) => (
                  <Tab
                    key={tab.index}
                    label={tab.label}
                  />
                ))}
              </Tabs>
            </Box>

            {/* Alumni Card - Styled as card within card */}
            <Box
              sx={{
                width: '100%',
                minHeight: { xs: '120px', sm: '156px' },
                borderRadius: '12px',
                backgroundColor: '#FFF4E6',
                p: { xs: 1.5, sm: 2 },
                mt: 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} xl={9} lg={9}>
                  <Typography
                    className={classes.profileDesignation}
                    sx={{
                      fontSize: { xs: '14px', sm: '16px' },
                      lineHeight: { xs: '1.2', sm: '1.5' }
                    }}
                  >
                    {profileData?.Specialization__c}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={3} lg={3}>
                  <Typography
                    className={classes.profileDesignation}
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: '14px', sm: '16px' }
                    }}
                  >
                    {profileData?.Year_of_Graduation__c ? profileData?.Year_of_Graduation__c : ""}
                  </Typography>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                onClick={handleOpen}
                className={classes.viewidbutton}
                fullWidth
                sx={{
                  mt: 1,
                  height: { xs: '36px', sm: '40px' },
                  fontSize: { xs: '13px', sm: '14px' }
                }}
              >
                View Alumni ID Card
              </Button>
              <Modal open={open} onClose={(_, reason) => reason !== "backdropClick" && handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <IdCard IdCardData={profileData?.ID_Card_URL__c} handleClose={handleClose} />
              </Modal>
            </Box>


          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={9} md={12} xl={9}>
          <Card
            id="profile-content-area"
            className={classes.profileCard}
            sx={{ height: '82.5vh', display: 'flex', flexDirection: 'column' }}
          >
            <Box
              sx={{
                p: 3,
                borderBottom: '1px solid #E6E6E8',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                justifyContent: { xs: 'flex-start', sm: 'space-between' },
                gap: { xs: 2, sm: 0 }
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                  mb: { xs: 1, sm: 0 }
                }}
              >
                {tabConfig[value]?.label}
              </Typography>
              {value === 2 && (
                <AppButton
                  size="medium"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleOpenAcademicRecord}
                  sx={{
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '36px',
                    width: { xs: '100%', sm: 'auto' }
                  }}
                >
                  Add academic record
                </AppButton>
              )}
            </Box>

            <Box className={classes.contentArea} sx={{ flex: 1, overflow: 'auto', p: 0 }}>
              <CustomTabPanel value={value} index={0}>
                <PersonalInformation setIsFormUnchanged={() => { }} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                {showCareerDetails ? (
                  <CareerDetailsContent
                    initialTab={careerDetailsTab}
                    onBack={() => setShowCareerDetails(false)}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: '68.5vh',
                      '@media (min-width: 1270px) and (max-width: 1290px)': {
                        height: '80vh !important',
                      },
                      '@media (min-width: 1536px) and (max-width: 1636px)': {
                        height: '67.5vh !important',
                      },
                      '@media (min-width: 1920px) and (max-width: 2000px)': {
                        height: '71.5vh',
                      },
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        height: '61vh !important',
                      },
                    }}
                    className="scrollbar-cusgray"
                  >
                    <Box className={classes.carrierBox}>
                      {/* Tab Header */}
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3,
                        position: 'relative',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 2, sm: 0 },
                        '&::after': {
                          content: '""',
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: '1px',
                          background: 'linear-gradient(270deg, rgba(191, 206, 255, 0) 0%, #BFCEFF 100%)',
                          zIndex: 1
                        }
                      }}>
                        <Box sx={{
                          display: 'flex',
                          gap: 0,
                          position: 'relative',
                          width: { xs: '100%', sm: 'auto' },
                          overflowX: { xs: 'auto', sm: 'visible' },
                          '&::-webkit-scrollbar': {
                            display: 'none'
                          },
                          msOverflowStyle: 'none',
                          scrollbarWidth: 'none'
                        }}>
                          <Box
                            onClick={() => setCarrierJobs('AppliedJobs')}
                            sx={{
                              cursor: 'pointer',
                              padding: '8px 16px',
                              position: 'relative',
                              color: carrierJobs === 'AppliedJobs' ? '#000' : '#666',
                              fontWeight: carrierJobs === 'AppliedJobs' ? 600 : 400,
                              fontSize: '14px',
                              transition: 'all 0.2s ease',
                              whiteSpace: 'nowrap',
                              '&:hover': {
                                color: '#000'
                              },
                              '&::after': carrierJobs === 'AppliedJobs' ? {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: '2px',
                                backgroundColor: '#FF9500',
                                zIndex: 2
                              } : {}
                            }}
                          >
                            Applied
                          </Box>
                          <Box
                            onClick={() => setCarrierJobs('SavedJobs')}
                            sx={{
                              cursor: 'pointer',
                              padding: '8px 16px',
                              position: 'relative',
                              color: carrierJobs === 'SavedJobs' ? '#000' : '#666',
                              fontWeight: carrierJobs === 'SavedJobs' ? 600 : 400,
                              fontSize: '14px',
                              transition: 'all 0.2s ease',
                              whiteSpace: 'nowrap',
                              '&:hover': {
                                color: '#000'
                              },
                              '&::after': carrierJobs === 'SavedJobs' ? {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: '2px',
                                backgroundColor: '#FF9500',
                                zIndex: 2
                              } : {}
                            }}
                          >
                            Saved
                          </Box>
                          <Box
                            onClick={() => setCarrierJobs('PostedByMe')}
                            sx={{
                              cursor: 'pointer',
                              padding: '8px 16px',
                              position: 'relative',
                              color: carrierJobs === 'PostedByMe' ? '#000' : '#666',
                              fontWeight: carrierJobs === 'PostedByMe' ? 600 : 400,
                              fontSize: '14px',
                              transition: 'all 0.2s ease',
                              whiteSpace: 'nowrap',
                              '&:hover': {
                                color: '#000'
                              },
                              '&::after': carrierJobs === 'PostedByMe' ? {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: '2px',
                                backgroundColor: '#FF9500',
                                zIndex: 2
                              } : {}
                            }}
                          >
                            Posted by me
                          </Box>
                        </Box>

                        <Box sx={{
                          display: 'flex',
                          gap: 1,
                          width: '100%',
                          justifyContent: { xs: 'space-between', sm: 'flex-end' },
                          mt: { xs: 1, sm: 0 },
                          ...(carrierJobs !== 'PostedByMe' && {
                            flexDirection: { xs: 'column', sm: 'row' }
                          })
                        }}>
                          {/* Show Post Job button only for Posted by me tab */}
                          {carrierJobs === 'PostedByMe' && (
                            <Box sx={{
                              width: { xs: '48%', sm: 'auto' }
                            }}>
                              <AppButton
                                size="small"
                                variant="contained"
                                onClick={() => navigate(routes.postJob)}
                                others={{
                                  backgroundColor: '#FF9500',
                                  color: 'white',
                                  borderRadius: '6px',
                                  height: '32px',
                                  fontSize: '12px',
                                  fontWeight: 500,
                                  width: '100%'
                                }}
                              >
                                + Post a job
                              </AppButton>
                            </Box>
                          )}

                          {/* View more button - show for all tabs */}
                          <Box sx={{
                            width: {
                              xs: carrierJobs === 'PostedByMe' ? '48%' : '100%',
                              sm: 'auto'
                            }
                          }}>
                            <AppButton
                              size="small"
                              variant="outlined"
                              onClick={() => {
                                const tabParam = carrierJobs === 'AppliedJobs' ? 'Applied' :
                                  carrierJobs === 'SavedJobs' ? 'Saved' : 'Posted by me';
                                setCareerDetailsTab(tabParam);
                                setShowCareerDetails(true);
                              }}
                              others={{
                                color: '#B8860B',
                                borderColor: '#B8860B',
                                borderRadius: '6px',
                                height: '32px',
                                fontSize: '12px',
                                fontWeight: 500,
                                width: '100%'
                              }}
                            >
                              View more
                            </AppButton>
                          </Box>
                        </Box>
                      </Box>
                      {/* Tab Content */}
                      <Box sx={{ minHeight: '300px' }}>
                        {carrierJobs === 'AppliedJobs' && (
                          <>
                            {appliedData?.length > 0 ? (
                              <Grid container spacing={2}>
                                {appliedData.slice(0, 3).map((val: any, index: number) => (
                                  <Grid key={index} item xs={12} sm={12} md={12} xl={4} lg={4}>
                                    <AppliedJobCards value={val} userData={userData} />
                                  </Grid>
                                ))}
                              </Grid>
                            ) : (
                              <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '200px',
                                textAlign: 'center',
                                color: '#666'
                              }}>
                                <Typography variant="h6" sx={{ mb: 1, color: '#999' }}>
                                  No Applied Jobs
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#999' }}>
                                  You haven't applied to any jobs yet.
                                </Typography>
                              </Box>
                            )}
                          </>
                        )}

                        {carrierJobs === 'SavedJobs' && (
                          <>
                            {savedJobsData?.length > 0 ? (
                              <Grid container spacing={2}>
                                {savedJobsData.slice(0, 3).map((val: any, index: number) => (
                                  <Grid key={index} item xs={12} sm={12} md={12} xl={4} lg={4}>
                                    <AppliedJobCards value={val} userData={userData} />
                                  </Grid>
                                ))}
                              </Grid>
                            ) : (
                              <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '200px',
                                textAlign: 'center',
                                color: '#666'
                              }}>
                                <Typography variant="h6" sx={{ mb: 1, color: '#999' }}>
                                  No Saved Jobs
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#999' }}>
                                  You haven't saved any jobs yet.
                                </Typography>
                              </Box>
                            )}
                          </>
                        )}

                        {carrierJobs === 'PostedByMe' && (
                          <>
                            {jobsData?.length > 0 ? (
                              <Grid container spacing={2}>
                                {jobsData.slice(0, 3).map((val: any, index: number) => (
                                  <Grid key={index} item xs={12} sm={12} md={12} xl={4} lg={4}>
                                    <AppliedJobCards value={val} userData={userData} carrierJobs={carrierJobs} />
                                  </Grid>
                                ))}
                              </Grid>
                            ) : (
                              <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '200px',
                                textAlign: 'center',
                                color: '#666'
                              }}>
                                <Typography variant="h6" sx={{ mb: 1, color: '#999' }}>
                                  No Posted Jobs
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#999', mb: 2 }}>
                                  You haven't posted any jobs yet.
                                </Typography>
                                <AppButton
                                  size="small"
                                  variant="contained"
                                  onClick={() => navigate(routes.postJob)}
                                  others={{
                                    backgroundColor: '#FF9500',
                                    color: 'white',
                                    borderRadius: '6px',
                                    height: '36px',
                                    fontSize: '12px',
                                    fontWeight: 500
                                  }}
                                >
                                  + Post your first job
                                </AppButton>
                              </Box>
                            )}
                          </>
                        )}
                      </Box>
                    </Box>
                    <Box className={classes.carrierBox}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={6} md={8} xl={8} lg={8}>
                          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                            <Typography
                              fontWeight={'500'}
                              sx={{
                                fontSize: '15px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                              color={'#373A45'}
                            >
                              Resume Library
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} xl={4} lg={4}>
                          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            {/* <AppButton
                            size="small"
                            variant="contained"
                            className={classes.postJobBtns}
                            others={{
                              color: KenColors.kenBlack,
                              borderRadius: '6px',
                              height: '36px',
                              width: '144px',
                              backgroundColor: '#E8EBF3',
                            }}
                            background={KenColors.ClientPrimaryGrey}

                          > */}
                            <Box className={classes.iconBox} onClick={handleClick}>
                              <AddIcon
                                sx={{
                                  fontSize: '18px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              />
                            </Box>
                            {/* </AppButton> */}
                          </Box>
                        </Grid>
                      </Grid>

                      {/* fctyguhu */}
                      <Modal open={opens} onClose={(_, reason) => reason !== "backdropClick" && handleCloses} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                          <Grid container>
                            <Grid item xs={6}>
                              <Typography
                                sx={{
                                  fontWeight: 500,
                                  fontSize: '15px',
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '11px',
                                  },
                                }}
                              >
                                How would you like to proceed?
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                              <CloseIcon
                                sx={{
                                  cursor: 'pointer',
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '15px',
                                  },
                                }}
                                onClick={() => {
                                  handleCloses();
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid>
                            <hr className={classes.hrLine} />
                          </Grid>
                          <Grid container style={{ margin: '10px', backgroundColor: '#F5F6F8', borderRadius: '6px', padding: '10px', cursor: "pointer" }} onClick={() => navigate(`${routes.resumeLibrary}?open=true`)}>
                            <Grid item xs={11}>
                              Upload resume
                            </Grid>
                            <Grid item xs={1}>
                              <DriveFolderUploadIcon />
                            </Grid>
                          </Grid>
                          <Grid container style={{ margin: '10px', backgroundColor: '#F5F6F8', borderRadius: '6px', padding: '10px', cursor: "pointer" }} onClick={() => navigate(routes.resumeBuilder)}>
                            <Grid item xs={11}>
                              Create new resume
                            </Grid>
                            <Grid item xs={1}>
                              <ModeEditOutlineOutlinedIcon />
                            </Grid>
                          </Grid>
                        </Box>
                      </Modal>

                      <hr className={classes.hrLine} />
                      {resumeDataDetails?.length > 0 ? (
                        <Box>
                          {resumeDataDetails?.map((val: any, index: number) => {
                            return (
                              <Box key={index} sx={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: '12px',
                                padding: '16px',
                                marginBottom: '12px',
                                border: '1px solid #E6E6E8',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                              }}>
                                <Box sx={{
                                  width: '40px',
                                  height: '40px',
                                  backgroundColor: '#DC2626',
                                  borderRadius: '6px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: 'white',
                                  fontWeight: 'bold',
                                  fontSize: '12px'
                                }}>
                                  PDF
                                </Box>

                                <Box sx={{ flex: 1 }}>
                                  <Typography
                                    fontWeight={500}
                                    sx={{
                                      fontSize: '14px',
                                      color: '#1F2937',
                                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                                        fontSize: '12px !important',
                                      },
                                    }}
                                  >
                                    {val?.title}
                                  </Typography>
                                  <Typography
                                    fontWeight={400}
                                    sx={{
                                      fontSize: '12px',
                                      color: '#6B7280',
                                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                                        fontSize: '10px !important',
                                      },
                                    }}
                                  >
                                    Last used on 23/03/2024
                                  </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <Box
                                    sx={{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '6px',
                                      backgroundColor: '#F3F4F6',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        backgroundColor: '#E5E7EB'
                                      }
                                    }}
                                  >
                                    <EditIcon sx={{ fontSize: '16px', color: '#6B7280' }} />
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '6px',
                                      backgroundColor: '#F3F4F6',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        backgroundColor: '#E5E7EB'
                                      }
                                    }}
                                    onClick={() => handleDownload(val.title, val.base64Data)}
                                  >
                                    <SaveAltIcon sx={{ fontSize: '16px', color: '#6B7280' }} />
                                  </Box>
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      ) : (
                        <Box sx={{ height: '20vh', mt: 5 }} className="scrollbar-cusgray">
                          <img src={resumeNoDataImg} height={'45px'} width={'45px'} />
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontWeight: 500,
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '10px !important',
                              },
                            }}
                          >
                            You do not have any resumes here
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontWeight: 400,
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '10px !important',
                              },
                            }}
                          >
                            Create now!
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Box className={classes.carrierBox}>
                      <Grid container spacing={2}>
                        <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                            <Typography
                              fontWeight={'550'}
                              sx={{
                                fontSize: '16px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              Employment Details
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Box className={classes.iconBox} onClick={handleOpenEmployeeAdd}>
                              <AddIcon
                                sx={{
                                  fontSize: '18px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              />
                            </Box>
                            <Modal open={openEmployeeAdd} onClose={(_, reason) => reason !== "backdropClick" && handleCloseEmployeeAdd()} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                              <AddEmployeeDetails handleClose={handleCloseEmployeeAdd} data={'add'} userData={userData} value={''} setPreferStatus={setPreferStatus} />
                            </Modal>
                          </Box>
                        </Grid>
                      </Grid>
                      <hr className={classes.hrLine} />
                      <Box>
                        {employeeDetails?.map((val: any) => {
                          console.log(employeeDetails, "valvalvalvalvalvalvalval");
                          return (
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                              <Grid item xs={3} sm={3} md={3} lg={1} xl={1}>
                                <Box sx={{ height: '48px', width: '48px' }}>
                                  <img
                                    src={val?.Company__r?.Logo_File_URL__c ? val?.Company__r?.Logo_File_URL__c : 'https://alumnikenverse.blob.core.windows.net/images/png-clipart-job-hunting-symbol-computer-icons-employment-symbol-miscellaneous-text-thumbnail.png'}
                                    height="100%"
                                    width="100%"
                                    onError={(e: any) => {
                                      e.target.src = 'https://alumnikenverse.blob.core.windows.net/images/png-clipart-job-hunting-symbol-computer-icons-employment-symbol-miscellaneous-text-thumbnail.png';
                                    }}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={9} sm={9} md={9} lg={6} xl={6}>
                                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                  <Typography
                                    sx={{
                                      textAlign: 'left',
                                      fontSize: '15px',
                                      fontWeight: 500,
                                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                                        fontSize: '10.5px !important',
                                      },
                                    }}
                                  >
                                    {val.Title__c}
                                  </Typography>
                                  {
                                    val.Currently_working_here__c && (
                                      <Chip
                                        label="Currently working here"
                                        size="small"
                                        sx={{
                                          backgroundColor: '#C1DCC3',
                                          fontWeight: 500,
                                          fontSize: '12px',
                                          color: '#1F4E21',
                                          ml: 2,
                                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                                            fontSize: '10px',
                                          },
                                        }}
                                      />
                                    )}
                                </Box>
                                <Typography
                                  sx={{
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '10px !important',
                                    },
                                  }}
                                >
                                  {' '}
                                  {val?.Company__r?.Name} | {val.Employment_Type__c}
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: 'left',
                                    fontSize: '12px',
                                    color: '#1A358C',
                                    mt: 2,
                                    fontWeight: 500,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '9.5px !important',
                                    },
                                  }}
                                >
                                  {val?.Location__c}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: 'flex', justifyContent: 'end', ml: 5 }}>
                                <CalendarTodayOutlinedIcon sx={{ fontSize: '15px' }} />
                                <Typography
                                  sx={{
                                    ml: 1,
                                    fontSize: '12px',
                                    fontWeight: 400,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '9.5px !important',
                                    },
                                  }}
                                >
                                  {val.Start_Date__c ? new Date(val.Start_Date__c).toLocaleDateString('en-GB') : ''} - {val.Currently_working_here__c ? 'present' : val?.End_Date__c ? new Date(val.End_Date__c).toLocaleDateString('en-GB') : ''}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={1} xl={1} display={'flex'} justifyContent={'end'}>
                                <ModeEditOutlineOutlinedIcon
                                  style={{ fontSize: '15px', cursor: 'pointer' }}
                                  onClick={() => {
                                    handleOpenEmployeeEdit();
                                    setEmployeeDetailVal(val);
                                  }}
                                />
                                {!val?.LinkedIn_Sourced__c && (<DeleteIcon
                                  style={{ fontSize: '15px', cursor: 'pointer', marginLeft: '10px' }}
                                  onClick={() => {
                                    setOpenDeleteConfirmEmploy(true);
                                    setEmploymentId(val.Id);
                                  }}
                                />)}
                              </Grid>
                            </Grid>
                          );
                        })}
                        <Modal open={openEmployeeEdit} onClose={(_, reason) => reason !== "backdropClick" && handleCloseEmployeeEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                          <AddEmployeeDetails handleClose={handleCloseEmployeeEdit} data={'edit'} userData={userData} value={employeeDetailVal} setPreferStatus={setPreferStatus} />
                        </Modal>
                        <Modal open={openDeleteConfirmEmploy} onClose={handleCloseDeleteConfirm} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                          <Box sx={style}>
                            <Typography id="modal-modal-title" variant="h5" component="h2">
                              Confirm Deletion
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                              Are you sure you want to delete this Employment Details?
                            </Typography>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                              <Button onClick={() => handleCloseDeleteConfirm()} sx={{ mr: 1 }}>Cancel</Button>
                              <Button onClick={handleDeleteEmployment} variant="contained" color="error">Delete</Button>
                            </Box>
                          </Box>
                        </Modal>
                      </Box>
                    </Box>
                    <Box className={classes.carrierBox}>
                      <Grid container spacing={2}>
                        <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                            <Typography
                              fontWeight={'500'}
                              sx={{
                                fontSize: '15px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              Certificates
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Box className={classes.iconBox} onClick={handleOpenCertificateAdd}>
                              <AddIcon
                                sx={{
                                  fontSize: '18px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '15px',
                                  },
                                }}
                              />
                            </Box>
                            <Modal open={openCertificateAdd} onClose={(_, reason) => reason !== "backdropClick" && handleCloseCertificateAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                              <AddCertificateData handleClose={handleCloseCertificateAdd} userData={userData} data="add" setPreferStatus={setPreferStatus} value={''} />
                            </Modal>
                          </Box>
                        </Grid>
                      </Grid>
                      <hr className={classes.hrLine} />
                      <Box>
                        {certificateDetails?.map((val: any) => {
                          return (
                            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                              <Grid item xs={2} sm={2} md={2} lg={1} xl={1}>
                                <Box sx={{ height: '48px', width: '48px' }}>
                                  <img src={googleImg} height="90%" width="80%" />
                                </Box>
                              </Grid>
                              <Grid item xs={7} sm={7} md={6} lg={6} xl={6}>
                                <Typography
                                  sx={{
                                    textAlign: 'left',
                                    fontSize: '15px',
                                    fontWeight: 500,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '10px !important',
                                    },
                                  }}
                                >
                                  {val?.Name}
                                </Typography>
                                <Typography
                                  sx={{
                                    textAlign: 'left',
                                    fontSize: '12px',
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '9px !important',
                                    },
                                  }}
                                >
                                  {val?.Issuing_Organization__r?.Name ? val?.Issuing_Organization__r?.Name : "Google Certifications"}
                                </Typography>
                              </Grid>
                              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <Chip
                                  label={val.Issue_Date__c}
                                  sx={{
                                    backgroundColor: '#BFCEFF',
                                    borderRadius: 10,
                                    p: 1,
                                    pt: 1,
                                    pb: 1,
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    ml: { lg: 9, xl: 9 },
                                    color: '#1A358C',
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '10px',
                                    },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={2} xl={2} display={'flex'} justifyContent={'end'}>
                                <ModeEditOutlineOutlinedIcon
                                  sx={{
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '12px',
                                    },
                                  }}
                                  onClick={() => {
                                    handleOpenCertificateEdit();
                                    setCertificateDetailVal(val);
                                  }}
                                />
                                {!val?.LinkedIn_Sourced__c && (<DeleteIcon
                                  style={{ fontSize: '15px', cursor: 'pointer', marginLeft: '10px' }}
                                  onClick={() => {
                                    // Add your delete logic here
                                    setOpenDeleteConfirm(true);
                                    setCertificateId(val.Id);
                                  }}
                                />)}
                              </Grid>
                            </Grid>
                          );
                        })}
                        <Modal open={openCertificateEdit} onClose={(_, reason) => reason !== "backdropClick" && handleCloseCertificateEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                          <AddCertificateData handleClose={handleCloseCertificateEdit} userData={userData} data="edit" setPreferStatus={setPreferStatus} value={certificateDetailVal} />
                        </Modal>
                        <Modal open={openDeleteConfirm} onClose={(_, reason) => reason !== "backdropClick" && handleCloseDeleteConfirm} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                          <Box sx={style}>
                            <Typography id="modal-modal-title" variant="h5" component="h2">
                              Confirm Deletion
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                              Are you sure you want to delete this certificate?
                            </Typography>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                              <Button onClick={() => handleCloseDeleteConfirm()} sx={{ mr: 1 }}>Cancel</Button>
                              <Button onClick={handleDeleteCertificate} variant="contained" color="error">Delete</Button>
                            </Box>
                          </Box>
                        </Modal>
                      </Box>
                    </Box>
                    <Box className={classes.carrierBox}>
                      <Grid container spacing={2}>
                        <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                            <Typography
                              fontWeight={'550'}
                              sx={{
                                fontSize: '15px',
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              Skills
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            {/* {!editSkills && skill?.length > 0 ? (<Box className={classes.iconBox} onClick={() => {
                            setEditSkills(true);
                          }}>
                            <EditIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>) : null} */}
                            {/* <Modal open={openSkillsEdit} onClose={handleCloseSkillsEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <AddSkill handleClose={handleCloseSkillsEdit} data="edit" />
                          </Modal> */}

                            <Box className={classes.iconBox} onClick={handleOpenSkillsAdd} sx={{ ml: 1 }}>
                              <EditIcon
                                sx={{
                                  fontSize: '18px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              />
                            </Box>
                            <Modal open={openSkillsAdd} onClose={(_, reason) => reason !== "backdropClick" && handleCloseSkillsAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                              <AddSkill handleClose={handleCloseSkillsAdd} skills={profileData} setSkill={setSkill} />
                            </Modal>
                          </Box>
                        </Grid>
                      </Grid>
                      <hr className={classes.hrLine} />
                      <Box sx={{ display: 'flex', justifyContent: 'start', marginTop: '-35px' }}>
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'start', mt: 2, flexDirection: "column" }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', mt: 1.5, ml: 1 }}>
                            {profileData?.Skills__c?.split(';').map((skill: string, index: number) => (
                              <Grid
                                key={index}
                                item
                                sx={{
                                  backgroundColor: '#c4c4c4',
                                  borderRadius: '12px',
                                  margin: "5px",
                                  padding: "2px 14px 2px 14px",
                                  textAlign: 'center',
                                }}
                              >
                                <Typography variant="body1" sx={{ color: 'white' }}>
                                  {skill}
                                </Typography>
                              </Grid>
                            ))}
                          </Box>
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                )}
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                {academicRecords == 'RequestCertificate' ? (
                  <Box
                    sx={{
                      height: {
                        lg: '68.5vh',
                        xl: '68.5vh',
                        '@media (min-width: 1270px) and (max-width: 1290px)': {
                          height: '80vh !important',
                        },
                        '@media (min-width: 1536px) and (max-width: 1636px)': {
                          height: '67.5vh !important',
                        },
                        '@media (min-width: 1920px) and (max-width: 2000px)': {
                          height: '71.5vh',
                        },
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          height: '61vh !important',
                        },
                      },
                    }}
                    className="scrollbar-cusgray"
                  >
                    {academicRecordData?.map((val: any) => {
                      const startDate = val?.Start_Date__c ? moment(val.Start_Date__c).format("DD-MM-YYYY") : "";
                      const endDate = val?.End_Date__c ? moment(val.End_Date__c).format("DD-MM-YYYY") : "";

                      const formattedDateRange = `${startDate} - ${endDate}`;
                      console.log(formattedDateRange);
                      return (
                        <Box className={classes.academicRecordBox}>
                          <Grid container spacing={2}>
                            <Grid item xs={4} sm={4} md={4} lg={1.5} xl={1.5} xxl={1}>
                              <Box
                                sx={{
                                  height: '72px',
                                  width: '72px',
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    height: '60px',
                                    width: '60px',
                                  },
                                }}
                              >
                                <img src={AcademicRecordImg} height="100%" width="100%" />
                              </Box>
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={5} xl={5} xxl={6}>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontWeight: 500,
                                  marginTop: '10px',
                                  fontSize: '12px',
                                  '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '10.5px',
                                  },
                                }}
                              >
                                {val?.Name_of_the_institute__r?.Name}
                              </Typography>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontWeight: 600,
                                  fontSize: '10.5px',
                                  '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '9.5px',
                                  },
                                }}
                              ></Typography>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  marginTop: '5px',
                                  color: '#2C58E8',
                                  fontWeight: 500,
                                  fontSize: '10.5px',
                                  '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    marginLeft: '15px',
                                  },
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '9px',
                                  },
                                }}
                              >
                                {val?.Grade_Type__c == 'CGPA' ? 'CGPA' : 'Percentage'}: {val?.Grade__c} | {formattedDateRange}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={5.5} xl={5.5} xxl={5}>
                              <Box sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                gap: { xs: 1, sm: 1 },
                                width: '100%',
                                justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                                alignItems: { xs: 'stretch', sm: 'center' }
                              }}>
                                <Box sx={{ width: '100%', '@media (min-width: 600px)': { width: 'auto' } }}>
                                  <AppButton
                                    size="small"
                                    variant="contained"
                                    className={classes.postJobBtns}
                                    sx={{
                                      color: acedmicStatus ? KenColors.kenBlack : KenColors.kenWhite,
                                      height: '27px',
                                      width: '100%',
                                      '@media (min-width: 600px)': {
                                        width: 'auto',
                                        ml: 1
                                      }
                                    }}
                                    background={acedmicStatus ? KenColors.ClientPrimaryGrey : ''}
                                    onClick={() => {
                                      setAcademicStatus(false);
                                      setAcademicRecords('RequestCertificate');
                                      navigate('/service & support/RequestService', { state: { breadcrumbs: ['Home', 'Requests'] } });
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: '10.5px',
                                        fontWeight: 500,
                                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                                          fontSize: '9px',
                                        },
                                      }}
                                    >
                                      Request Certificate
                                    </Typography>
                                  </AppButton>
                                </Box>

                                {!val?.LinkedIn_Sourced__c ? (
                                  <Box sx={{
                                    display: 'flex',
                                    gap: '10px',
                                    justifyContent: { xs: 'flex-end', sm: 'flex-start' },
                                    mt: { xs: 1, sm: 0 }
                                  }}>
                                    <EditIcon
                                      sx={{
                                        fontSize: '15px',
                                        cursor: 'pointer',
                                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                                          fontSize: '12px',
                                        },
                                      }}
                                      onClick={() => {
                                        setAcademicRecordDataVal(val);
                                        handleOpenAcademicRecord();
                                        setAcademicRecordStatus(true);
                                      }}
                                    />
                                    <DeleteIcon
                                      style={{ fontSize: '15px', cursor: 'pointer' }}
                                      onClick={() => {
                                        setOpenDeleteConfirm(true);
                                        setCertificateId(val.Id);
                                      }}
                                    />
                                  </Box>
                                ) : null}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      );
                    })}

                    <Modal open={openAcademicRecord} onClose={(_, reason) => reason !== "backdropClick" && handleCloseAcademicRecord} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                      <AddAcademicRecord editData={academicRecordVal} handleClose={handleCloseAcademicRecord} userData={userData} setAcademicRecordStatus={setAcademicRecordStatus} />
                    </Modal>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      height: {
                        lg: '69.5vh',
                        xl: '69.5vh',
                      },
                      '@media (min-width: 1270px) and (max-width: 1290px)': {
                        height: '80vh !important',
                      },
                      '@media (min-width: 1536px) and (max-width: 1636px)': {
                        height: '68.5vh !important',
                      },
                      '@media (min-width: 1920px) and (max-width: 2000px)': {
                        height: '73vh',
                      },
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        height: '61vh !important',
                      },
                    }}
                  >
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} xl={7} lg={7} sx={{ display: 'flex', justifyContent: 'start', mt: 1 }}>
                          <KeyboardBackspaceSharpIcon
                            sx={{ mt: 0.2, fontSize: '15px' }}
                            onClick={() => {
                              setAcademicRecords('RequestCertificate');
                              setAcademicStatus(false);
                            }}
                          />
                          &nbsp;
                          <Typography
                            sx={{
                              textAlign: 'left',
                              fontWeight: 500,
                              fontSize: '12px',
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '11px',
                              },
                            }}
                          >
                            B Tech, Electronics and Media Technology
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={5} lg={5} sx={{ display: 'flex', justifyContent: { xs: 'start', sm: 'start', lg: 'end', xl: 'end', md: 'end' } }}>
                          <FormControl sx={{ minWidth: { xs: '100%', sm: '100%', lg: 350, xl: 350, md: 350 } }} size="small">
                            <InputLabel id="demo-simple-select-label">Select Semester</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={semester}
                              label="Select Semester"
                              onChange={handleChangeSemester}
                              sx={{
                                borderRadius: 2,
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#3061FF',
                                },
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderRadius: 2,
                                },
                              }}
                            >
                              <MenuItem
                                value={'Semester I'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester I
                              </MenuItem>
                              <MenuItem
                                value={'Semester II'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester II
                              </MenuItem>
                              <MenuItem
                                value={'Semester III'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester III
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <TableContainer />
                    </Box>
                  </Box>
                )}
              </CustomTabPanel>

              {/* Events Tab */}
              <CustomTabPanel value={value} index={3}>
                <EventsContent />
              </CustomTabPanel>
              {/* Groups Tab */}
              <CustomTabPanel value={value} index={4}>
                <GroupsContent />
              </CustomTabPanel>

              {/* Mentorship Tab */}
              <CustomTabPanel value={value} index={5}>
                <MentorshipContent />
              </CustomTabPanel>

              {/* Fundraise Tab */}
              <CustomTabPanel value={value} index={6}>
                <FundraiseContent />
              </CustomTabPanel>

              {/* Businesses Tab */}
              <CustomTabPanel value={value} index={7}>
                <BusinessesContent />
              </CustomTabPanel>
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* Campaign Creation Dialog */}
      <CampaignDialog
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onProceed={() => setDialogOpen(false)}
      />
    </div>
  );
}